import '@bjb/bjb-web-components/dist/components/jb-components.js';

import { html, LitElement, nothing, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

import { customElement } from '@bjb-web-components/assets/scripts/CustomElementsUtils';
import type { IInfoTeaserHeader } from './adesso-info-teaser-header.custom';
import componentStyles from './adesso-info-teaser-header.scss?inline';

@customElement('adesso-info-teaser-header')
export class AdessoInfoTeaserHeader extends LitElement implements IInfoTeaserHeader {
  static styles = unsafeCSS(componentStyles);

  @property()
  headline: IInfoTeaserHeader['headline'] = '';

  @property({ type: Object })
  picture: IInfoTeaserHeader['picture'];

  @property()
  teaser: IInfoTeaserHeader['teaser'];

  @property({ type: Object })
  thumbnail: IInfoTeaserHeader['thumbnail'];

  _renderPreview() {
    if (this.thumbnail) {
      return html`<jb-thumbnail
        .backgroundPicture="${this.thumbnail.backgroundPicture}"
        .videoSrc="${this.thumbnail.videoSrc}"
        .aspect="${this.thumbnail.aspect}"
        .type="${this.thumbnail.type}"
      ></jb-thumbnail>`;
    }
    if (this.picture) {
      return html`<jb-picture
        .alt=${this.picture.alt}
        .fit=${this.picture.fit ?? 'cover'}
        .imgData=${this.picture.imgData}
        .lazy=${this.picture.lazy}
        .aspect=${this.picture.aspect ?? 'aspect_3by2'}
      ></jb-picture>`;
    }
    return null;
  }

  _renderTeaser() {
    if (this.teaser) {
      return html`<p>${this.teaser}</p>`;
    }
    return null;
  }

  render() {
    return html`<header class="${classMap({ no_image: !this.thumbnail && !this.picture })}">
      ${this._renderPreview()} ${this.headline ? html`<h3>${this.headline}</h3>` : nothing}
      ${this.teaser ? this._renderTeaser() : nothing}
    </header>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'adesso-info-teaser-header': AdessoInfoTeaserHeader;
  }
}
